import { memo, useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { selectScalperTradeOptions } from "../../../selectors/scalper";
import { SvgIcon, Tooltip } from "@mui/material";
import FlashIcon from "../../../assets/icons/Flash";
import { ExtraSmallButton } from "../../../components/custom";
import { blue } from "../../../assets/colors";
import { useDispatch } from "react-redux";
import { setTradeOptions } from "../../../reducer/scalper.reducer";
import ScalperSettingsMenu from "../scalperSettingsMenu/scalperSettingsMenu";


const ScalperActionBar: React.FC = () => {
    const dispatch = useDispatch();
    const tradeOptions = useSelector(selectScalperTradeOptions);
    const onClick = useCallback(() => {
        if (!tradeOptions) return;
        dispatch(setTradeOptions({ quickTrade: !tradeOptions.quickTrade }))

    }, [tradeOptions])

    const quickTradeToggle = useMemo(() => (
        <Tooltip title="Toggle Quick Trade"><ExtraSmallButton id="scalper-quick-trade-toggle" size="small" sx={{color: tradeOptions?.quickTrade ? blue : "inherit"}} onClick={onClick} > <SvgIcon sx={{fontSize: "18px"}}> <FlashIcon /></SvgIcon></ExtraSmallButton></Tooltip>
    ), [tradeOptions, onClick])



    return <>
    {quickTradeToggle}
    <ScalperSettingsMenu />
    </>
};

export default memo(ScalperActionBar);
